// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__qzkXM","tooltip-fade-in":"Tooltip_tooltip-fade-in__AiRrb","tooltip-fade-out":"Tooltip_tooltip-fade-out__o8wiA"};